import React, { useContext } from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';

import { GlobalContext } from '../../store';

import Notification from '../Notification/Notification';

export const EmptyHeader = () => {
  const { loader } = useContext(GlobalContext);

  return (
    <>
      <Notification />

      <div className={`loading-modal ${loader.activeRequests > 0 ? '' : '-hidden'}`}>
        <CircularProgress className="loading" color="secondary" />
      </div>
    </>
  );
};
